import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import bga from "../assets/aboutbg.webp";
import img from "../assets/mockup.webp";
import Footer from "./Footer";
import img2 from "../assets/bgdiv.png";
import ScrollToTop from '../Components/Scroll.js'
const Services = () => {
  return (
    <>
      <Navbar></Navbar>
      <div className="relative w-full h-[300px]">
        {/* Background Image */}
        <img src={bga} alt="About Us" className="w-full h-full object-cover" />

        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-6xl font-bold drop-shadow-md">
            About Us
          </h1>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center text-center p-4 bg-white mt-12">
  <div className="max-w-4xl w-full">
    <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4">
      Welcome to{" "}
      <span className="text-green-600">Axion's Healthcare Services</span>!
    </h1>
    <p className="text-lg sm:text-xl md:text-2xl pt-1 font-sans font-medium text-gray-700 leading-relaxed">
      Medical Billing is not only a science; it is also an art. It does
      not consist of compounding bills; it deals with the very processes
      of revenue cycle management, which must be understood before they
      may be guided for increased efficiency.
    </p>
  </div>
</div>

<div className="flex flex-col md:flex-row w-full h-auto md:h-[500px]">
  {/* Left Side - Blue Div with Text */}
  <div className="bg-gray-400 w-full md:w-3/4 flex items-center justify-center p-6">
    <div className="text-black text-lg font-normal font-serif leading-relaxed max-w-[90%] mx-auto">
      <p className="mb-4">
        Axion Medical Billing Services LLC is an advanced healthcare,
        information-technology-based company that provides solutions
        offering physicians' practices comprehensive practice management
        services & revenue cycle management solutions. We also provide
        transcription and data management solutions.
      </p>
      <p className="mb-4">
        We provide high-quality service to physicians by maximizing their
        revenue collection and reducing their workload, thereby allowing
        them to provide the best quality care to their patients. At Axion,
        our aim is to provide Practice Management Solutions to maximize
        revenues and productivity.
      </p>
      <p>
        Medical Billing is getting more complex nowadays as the healthcare
        industry is changing every day. While healthcare keeps changing,
        billing demands adherence to new compliance guidelines like HIPAA
        5010, ICD 10, and EHR ‘meaningful use’ guidelines. The best way
        out is to leave medical billing to experts and focus on what
        physicians do best.
      </p>
    </div>
  </div>

  {/* Right Side - Green Div with Image */}
  <div className="bg-green-400 w-full md:w-1/4 h-[250px] md:h-full flex items-center justify-center relative">
    <img
      src={img}
      alt="Example"
      className="w-[60%] md:w-[90%] h-auto object-cover"
    />
  </div>
</div>





      <div className="flex justify-center items-center py-8">
  <div className="max-w-4xl text-center px-4">
    {/* First Paragraph */}
    <p className="text-xl sm:text-lg font-sans font-medium text-gray-700 leading-relaxed mb-6">
      At Axion we provide exceptional Medical Billing Services, timely and accurate claims submission and effective claims follow up, which differentiates us from the rest of the billing companies. Our broad expertise in reimbursement management provides physicians with more revenue, time for patient care, and professional growth.
    </p>
    {/* Second Paragraph */}
    <p className="text-xl sm:text-lg font-sans font-medium text-gray-700 leading-relaxed">
      At Axion, we work with Healthcare Providers to achieve notable results in their earnings, and try to make sure that their billing cycle gets smoother more than ever. For this reason, it is very important to ensure that Insurance claims get billed out to insurance companies correctly in the first attempt, which in turn provides maximum reimbursement for the billed services. We are 100% HIPAA compliant.
    </p>
    <p className="text-3xl font-semibold font-sans text-green-500 my-5">
    Moreover, we automate physician business to derive efficiency:
    </p>
    <ul className="list-disc list-inside text-left text-lg text-gray-700 mb-6">
      <li className="font-semibold font-sans text-black">By Providing Top-Notch Billing Services</li>
      <li className="font-semibold font-sans text-black">By Providing Physicians with Significant Data</li>
      <li className="font-semibold font-sans text-black">By Providing Distinct Services to Clients</li>
      <li className="font-semibold font-sans text-black">By Maintaining High-Level Industry Standards</li>
    </ul>

  </div>
</div>


<div className="relative w-full h-[500px]">
  {/* Background Image */}
  <img
    src={img2}
    alt="Your Image"
    className="w-full h-full object-cover"
  />

  {/* Cards Container */}
  <div className="absolute top-10 right-0 grid grid-cols-2 gap-8 p-6 sm:p-8 max-w-[400px]">
    {/* Card 1 */}
    <div className="border-2 shadow-xl rounded-xl p-6 text-center backdrop-blur-md bg-white/20">
      <h3 className="text-5xl text-white font-bold mb-4">98%</h3>
      <p className="text-sm text-white">First Submission Pass Rate</p>
    </div>
    {/* Card 2 */}
    <div className="border-2 shadow-xl rounded-xl p-6 text-center backdrop-blur-md bg-white/20">
      <h3 className="text-5xl text-white font-bold mb-4">30%</h3>
      <p className="text-sm text-white">Increased Collections</p>
    </div>
    {/* Card 3 */}
    <div className="border-2 shadow-xl rounded-xl p-6 text-center backdrop-blur-md bg-white/20">
      <h3 className="text-5xl text-white font-bold mb-4">10+</h3>
      <p className="text-sm text-white">
        Years of Medical Billing Experience
      </p>
    </div>
    {/* Card 4 */}
    <div className="border-2 shadow-xl rounded-xl p-6 text-center backdrop-blur-md bg-white/20">
      <h3 className="text-5xl text-white font-bold mb-4">25%</h3>
      <p className="text-sm text-white">Expense Reduction</p>
    </div>
  </div>
</div>

<ScrollToTop></ScrollToTop>

      <Footer></Footer>
    </>
  );
};

export default Services;
